import * as fromDatatype from "../datatype-library/index";

export interface bl_cms_activities_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    facility_hdr_guid: fromDatatype.GuidDataFieldInterface;
    post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    tier_2_activity: boolean;
    tier_3_activity: boolean;
    title: fromDatatype.VarcharDatatypeInterface;
    duration: fromDatatype.VarcharDatatypeInterface;
    age: fromDatatype.VarcharDatatypeInterface;
    price: fromDatatype.VarcharDatatypeInterface;
    activity_image_guid: fromDatatype.VarcharDatatypeInterface;
    activity_image_url: fromDatatype.VarcharDatatypeInterface;
    related_activity: fromDatatype.VarcharDatatypeInterface;
    activity_configuration_json: fromDatatype.JsonDatatypeInterface;
}

export class bl_cms_activities_hdr_RowClass implements bl_cms_activities_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    facility_hdr_guid: fromDatatype.GuidDataFieldInterface;
    post_hdr_guid: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
    category_guid: fromDatatype.GuidDataFieldInterface;
    tier_2_activity: boolean;
    tier_3_activity: boolean;
    title: fromDatatype.VarcharDatatypeInterface;
    duration: fromDatatype.VarcharDatatypeInterface;
    age: fromDatatype.VarcharDatatypeInterface;
    price: fromDatatype.VarcharDatatypeInterface;
    activity_image_guid: fromDatatype.VarcharDatatypeInterface;
    activity_image_url: fromDatatype.VarcharDatatypeInterface;
    related_activity: fromDatatype.VarcharDatatypeInterface;
    activity_configuration_json: fromDatatype.JsonDatatypeInterface;
}
